import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

interface DataTableCardProps {
  title?: string;
  subtitle?: string;
  headerAction?: React.ReactNode;
  children: React.ReactNode;
}

const DataTableCard: React.FC<DataTableCardProps> = ({ title, subtitle, headerAction, children }) => (
  <Card>
    {(title || headerAction) && (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1,
          px: 3,
          pt: 2.5,
          pb: title ? 0 : 2.5,
        }}
      >
        <Box>
          {title && (
            <Typography variant="subtitle1" fontWeight={600}>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="caption" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        {headerAction}
      </Box>
    )}
    <CardContent sx={{ p: 0, '&:last-child': { pb: 0 }, overflowX: 'auto' }}>
      {children}
    </CardContent>
  </Card>
);

export default DataTableCard;
